type Unit = 'TON' | 'TRANSPORT' | 'PIECE';
type OptUnit = Unit | undefined;
type OptNum = number | undefined;

function normalize(unit: Unit): 'TON' | 'TRANSPORT' {
    return unit === 'PIECE' ? 'TRANSPORT' : unit;
}

export function deriveQuantity(qty: number, unit: Unit, targetUnit: Unit, payload: number): number;
export function deriveQuantity(qty: undefined, unit: OptUnit, targetUnit: Unit, payload: OptNum): undefined;
export function deriveQuantity(qty: OptNum, unit: OptUnit, targetUnit: Unit, payload: OptNum): OptNum;
export function deriveQuantity(qty: OptNum, unit: OptUnit, targetUnit: Unit, payload: OptNum): OptNum {
    if (qty === undefined || !unit || payload === undefined) {
        return undefined;
    }
    const sourceUnit = normalize(unit);
    const destUnit = normalize(targetUnit);
    if (destUnit === sourceUnit) {
        return qty;
    }
    if (destUnit === 'TRANSPORT') {
        return Math.ceil(qty / payload);
    }
    if (sourceUnit === 'TRANSPORT') {
        return qty * payload;
    }
    return qty;
}
